import {
  GET_PURCHASES_SECTOR,
  GET_PURCHASES_SECTOR_ERROR,
  GET_PURCHASES_SECTOR_SUCCESS
} from './ContingenciesPurchasesSectorSection.actions'

const contingenciesPurchasingMechanismsState = {
  categories: [],
  csv: [],
  data: [],
  error: null,
  loading: false
}

/**
 * The contingenciesPurchasesSectorReducer's reducer.
 */
const contingenciesPurchasesSectorReducer = (state = contingenciesPurchasingMechanismsState, { payload, type }) => {
  switch (type) {
    case GET_PURCHASES_SECTOR: {
      return { ...state, loading: true }
    }
    case GET_PURCHASES_SECTOR_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_PURCHASES_SECTOR_SUCCESS: {
      return { ...state, categories: payload.categories, csv: payload.csv, data: payload.data, loading: false }
    }
    default: {
      return state
    }
  }
}

export default contingenciesPurchasesSectorReducer
